import { render, staticRenderFns } from "./main-parameter.vue?vue&type=template&id=a96202ee&"
import script from "./main-parameter.vue?vue&type=script&lang=js&"
export * from "./main-parameter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports